<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p42"><span><a href="#/Contents#rp42">DILLED CUCUMBER BUTTERMILK SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>A refreshing soup for the dog days of summer!</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>⅔ cup chopped onion</span></p>
<p class="hang"><span>⅓ cup sliced green onions</span></p>
<p class="hang"><span>½ teaspoon minced garlic</span></p>
<p class="hang"><span>1 tablespoon margarine or butter</span></p>
<p class="hang"><span>1 medium russet potato, peeled, cubed</span></p>
<p class="hang"><span>2½ cups Rich Chicken Stock (see <a href="#/Chapter014#p4">p. 4</a>)</span></p>
<p class="hang"><span><a id="page_33"></a>2 medium cucumbers, peeled, seeded, chopped</span></p>
<p class="hang"><span>¼ cup chopped fresh or 1 tablespoon dried dill weed</span></p>
<p class="hang"><span>1 cup reduced-fat buttermilk</span></p>
<p class="hang"><span>Lemon juice, to taste</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>Dill Sour Cream (recipe follows)</span></p>
<p class="normalt"><span><b>1.</b> Sauté onion, green onions, and garlic in margarine in large saucepan until tender, about 4 minutes. Add potato and stock and heat to boiling; reduce heat and simmer, covered, until tender, about 15 minutes. Process soup, cucumbers, and dill in food processor or blender until smooth; stir in buttermilk and season to taste with lemon juice, salt, and white pepper. Refrigerate, covered, until chilled; tops each bowl of soup with dollop of Sour Cream with Dill.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 116</span></p>
<p class="per1"><span>% calories from fat: 22</span></p>
<p class="per1"><span>Protein (g): 6.2</span></p>
<p class="per1"><span>Carbohydrate (g): 15.5</span></p>
<p class="per1"><span>Fat (g): 2.8</span></p>
<p class="per1"><span>Saturated fat (g): 0.7</span></p>
<p class="per1"><span>Cholesterol (mg): 1.8</span></p>
<p class="per1"><span>Sodium (mg): 103</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 1.0</span></p>
<p class="normalt" id="p43"><span><b>Sour Cream with Dill</b></span></p>
<p class="make1"><span>Makes about ½ cup</span></p>
<p class="hang"><span>½ cup fat-free sour cream</span></p>
<p class="hang"><span>2 tablespoons chopped fresh or 1½ teaspoons dried dill weed</span></p>
<p class="normalt"><span><b>1.</b> Combine sour cream and dill.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0224.vue?6e246796